export default function useDefault<T,U>(props: T, value: U) {
    return Object.assign({},value,props);
}